<!-- サイドバーに出すグラフのテンプレート -->
<template>
  <div class="sidemenu-graph-list-template">
    <v-row no-gutters>
      <v-col cols="12" md="8">
        <v-card outlined tile>{{ graphTitle }}</v-card>
      </v-col>
      <v-col cols="6" md="4">
        <v-card outlined tile>
          <v-btn @click="addGraphFunction" text>追加</v-btn>
        </v-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="6">
        <v-card outlined tile>{{ graphDescription }}</v-card>
      </v-col>
      <v-col cols="6">
        <v-card outlined tile>
          <v-img
            alt="Graph Image"
            class="shrink mr-2"
            contain
            :src="imageUrl"
            transition="scale-transition"
          />
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "SideMenuGraphListTemplate",
  props: ["graphTitle", "graphDescription", "imageUrl"],
  methods: {
    addGraphFunction: function() {
      this.$emit("addGraphFunction", { index: this.index });
    }
  },
  data: function() {
    return {};
  }
};
</script>

<style scoped>
.sidemenu-graph-list-template {
  padding: 10px;
}
</style>